import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { BASE_URL } from '../constants'
import useFetch from '../hooks/useFetch'

import { fetchSuccess, fetchStart, fetchFail, toggle } from './actions'

import {
  getAllOverlayIds,
  getOverlayById,
  getSelectedOverlays
} from './selectors'

export const useOverlaysFetch = () => {
  const dispatch = useDispatch()

  return useFetch(`${BASE_URL}api/Overlays`, {
    onStart: () => dispatch(fetchStart()),
    onSuccess: overlays => dispatch(fetchSuccess(overlays)),
    onError: error => dispatch(fetchFail(error))
  })
}

export const useOverlay = overlayId => {
  const dispatch = useDispatch()
  const overlay = useSelector(getOverlayById)(overlayId)

  const _toggle = useCallback(() => dispatch(toggle(overlayId)), [
    overlayId,
    dispatch
  ])
  return [overlay, _toggle]
}

export const useOverlayIds = () => {
  const ids = useSelector(getAllOverlayIds)
  return ids
}

export const useSelectedOverlays = () => {
  const overlays = useSelector(getSelectedOverlays)
  return overlays
}
